import { gql } from '@apollo/client';

export const GET_SERVICE_CATEGORIES_FOR_CONTRACTOR = gql`
query {
  contractorServiceCategories {
    id
    name
    text
    image
    colour
    sortId
    selectable
  }
}
`;
